<template>
  <div
    :class="['book-landing flex no-wrap column full-height', { 'mobile': $q.platform.is.mobile }]"
    :styles="styles"
  >
    <div
      v-if="page.book.trackingCodes?.headerCode"
      v-html="page.book.trackingCodes.headerCode"
    />
    <HeaderComponent :data="landingPage.metaFields" />
    <AppBtn
      :label="$t('label.back')"
      icon="far fa-arrow-left"
      outline
      class="absolute-top-left back-btn bg-grey-1"
      :href="landingPage.publicUrl"
    />
    <div class="content">
      <div>
        <div class="title-h2 q-mb-lg">{{ page.title }}</div>
        <div v-html="page.content" />
      </div>
    </div>
    <FooterComponent :data="landingPage.metaFields" />
    <div
      v-if="page.book.trackingCodes?.footerCode"
      v-html="page.book.trackingCodes.footerCode"
    />
  </div>
</template>

<script setup>
/* eslint-disable */
import HeaderComponent from 'components/book-landing/render/HeaderComponent.vue';
import FooterComponent from 'components/book-landing/render/FooterComponent.vue';
import { ref, inject, onUnmounted, computed } from 'vue';
import useBookPageEdit from 'src/composables/useBookPageEdit';
import { useQuasar } from 'quasar';
import AppBtn from 'components/AppBtn.vue';

const $q = useQuasar();
const bus = inject('bus');

const props = defineProps({
  page: {
    type: Object,
    default: () => ({}),
  },
});

const landingPage = computed(() => props.page.book.pages.find(p => p.templateName === 'landing'));

const { styles } = useBookPageEdit(landingPage.value.metaFields);

const showEmailFormDialog = ref(false);


bus.on('open-email-form', () => {
  showEmailFormDialog.value = true;
});

onUnmounted(() => {
  bus.off('open-email-form');
});
</script>

<style lang="scss">
@import "../../../css/book-landing.scss";

.book-landing {
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  transition: width .4s;
  color: #000;

  .book-landing-top {
    height: 45px;
    position: sticky;
    top: 0;
    z-index: 4;
  }

  .content {
    width: 700px;
    margin: 44px auto;
  }

  .back-btn {
    margin-top: 100px;
    margin-left: 40px;
  }
}
</style>

<style lang="scss" scoped>
:deep(.iframe-wrapper) {
  border-radius: 20px;
}

.book-landing {
  overflow-y: scroll !important;

  &.mobile {
    :deep(.content) {
      width: 100%;
      padding: 50px 24px 0;

      h1 {
        font-size: 24px !important;
        line-height: 32px !important;
      }
      h2 {
        font-size: 22px;
        line-height: 32px;
      }
      h3 {
        font-size: 20px;
        line-height: 30px;
      }
      h4 {
        font-size: 18px;
        line-height: 28px;
      }
      h5 {
        font-size: 16px;
        line-height: 26px;
      }
    }

    .back-btn {
      margin-top: 80px;
      margin-left: 24px;
    }
  }
}

:deep(.content) {
  img {
    border-radius: 20px;
    width: 100%;
  }

  * {
    word-break: break-word;
  }
}
</style>
